// @flow
export { default } from './LabelInput';



// WEBPACK FOOTER //
// ./src/components/reset/LabelInput/index.js